<template>
  <b-card class="mx-auto b-card-pnf py-0" align="center">
    <div id="row-404">404</div><br>
    <div id="row-page-not-found">СТРАНИЦА НЕ НАЙДЕНА</div>
  </b-card>
</template>

<script>
export default {
  name: 'PageNotExist'
}
</script>

<style scoped>
  #row-404{
    font-size: 170px;
    font-weight: 900;
  }

  #row-page-not-found{
    font-size: 35px;
    font-weight: 700;
  }
  .b-card-pnf {
    width: 500px;
    top: calc((100vh - 418px - 80px) / 2);
    color: #017ac3;
    border: 1px solid #017ac3;
    -moz-box-shadow:0 0 10px #017ac3;
    -webkit-box-shadow:0 0 10px #017ac3;
    box-shadow:0 0 10px #017ac3;
  }
</style>
